import { all } from 'redux-saga/effects';
import authSaga from './auth/saga';
import purchaseOrderSaga from './purchaseOrder/saga';
import invoiceSaga from './invoice/saga';

const rootSaga = function* rootSaga() {
  yield all([
    authSaga(),
    purchaseOrderSaga(),
    invoiceSaga()
  ]);
};

export default rootSaga;
